// src/components/Products/Specials.jsx
import Special from './Special';
import { Link, useParams } from 'react-router-dom';

const Specials = ({ selectedSpecial, specials, setSelectedSpecialId }) => {
    const params = useParams();

    return (
        <div className='headless-specials'>
            {!selectedSpecial ? (
                specials.map((special) => (
                    <Special
                        key={special.id}
                        special={special}
                        singleSpecialView={false}
                        setSelectedSpecialId={setSelectedSpecialId}
                    />
                ))
            ) : (
                <>
                    <Link
                        className='headless-specials-view-all'
                        onClick={() => setSelectedSpecialId(null)}
                        to={`/shop/${params.locationSlug}/specials/`}
                    >
                        All Deals
                    </Link>
                    <Special
                        special={selectedSpecial}
                        singleSpecialView={true}
                        setSelectedSpecialId={setSelectedSpecialId}
                    />
                </>
            )}
        </div>
    );
};

export default Specials;
